import React from 'react';
import Footer from './components/Footer'
import MaskAnimation from './components/MaskAnimation';
import InViewComponent from './components/InView';
import AnimateIn from './components/AnimateIn';
import { useRef, useState, useEffect } from 'react';
import {useLang} from '../hook/UseLang'
import CONTENT from '../contents/privacy'
import '../App.css'
const Faq = () => {
    const [lang, setLang] = useLang()
    const text1Ref = useRef()
    const a0Ref = useRef()
    const a1Ref = useRef()
    const a2Ref = useRef()
    const a3Ref = useRef()
    const a4Ref = useRef()
    const a5Ref = useRef()
    const a6Ref = useRef()
    const a7Ref = useRef()
    const refArr = [a0Ref,a1Ref,a2Ref,a3Ref,a4Ref,a5Ref,a6Ref,a7Ref]
    const [DATA, setData] = useState([])
    useEffect(() => {
        const DATA = [
            {
                q:'',
                a:(<div className='flex flex-col' style={{gap:24}}>
                    <div>{CONTENT.q1[lang]}</div>
                </div>)
            },
            {
                q:CONTENT.q2[lang],
                a:(<div className='flex flex-col' style={{gap:24}}>
                   {CONTENT.q2_a[lang]}
                </div>)
            },
            {
                q:CONTENT.q3[lang],
                a:(<div className='flex flex-col' style={{gap:24}}>
                    <div>{CONTENT.q3_a[lang]}</div>
                </div>)
            },
            {
                q:CONTENT.q4[lang],
                a:(<div className='flex flex-col' style={{gap:24}}>
                    <div>{CONTENT.q4_a[lang]}</div>
                    <div className='flex flex-col mt-[48px]' style={{gap:24}}>
                        <div className='flex flex-row items-center justify-start'><span className='w-[3px] h-[3px] bg-black rounded-full mr-[12px]'></span>{CONTENT.q4_a1[lang]}</div>
                        <div className='flex flex-row items-center justify-start'><span className='w-[3px] h-[3px] bg-black rounded-full mr-[12px]'></span>{CONTENT.q4_a2[lang]}</div>
                        <div className='flex flex-row items-center justify-start'><span className='w-[3px] h-[3px] bg-black rounded-full mr-[12px]'></span>{CONTENT.q4_a3[lang]}</div>
                    </div>
                </div>)
            },
            {
                q:CONTENT.q5[lang],
                a:(<div className='flex flex-col' style={{gap:24}}>
                    <div>{CONTENT.q5_a[lang]}</div>
                </div>)
            },
            {
                q:CONTENT.q6[lang],
                a:(<div className='flex flex-col' style={{gap:24}}>
                    <div>{CONTENT.q6_a[lang]}</div>
                </div>)
            },
            {
                q:CONTENT.q7[lang],
                a:(<div className='flex flex-col' style={{gap:24}}>
                    <div>{CONTENT.q7_a[lang]}</div>
                </div>)
            },
            {
                q:CONTENT.q8[lang],
                a:(<div className='flex flex-col' style={{gap:24}}>
                    <div style={{whiteSpace:'pre-wrap', lineHeight:'24px'}}>{CONTENT.q8_a[lang]}</div>
                </div>)
            },
        ]
        setData(DATA)
    },[lang])
    return (
        <div className='w-full text-d-12 addnavpadding flex flex-col items-center noto-sans-hk'>
            <div className='relative w-full h-[15vh]'>
                <img src='./images/bg_texture.jpg' className='absolute w-full h-full' style={{objectFit:'cover'}}></img>
                <div ref={text1Ref} className='relative w-full h-full w-full flex flex-row items-center justify-center playfair-display font-bold text-d-35 title_text tracking-widest'>privacy policy</div>
                <InViewComponent reffing={text1Ref} active='title_text_active' delay={2000} />
            </div>
            <div className='w-full max-w-[650px] mt-[71px] flex flex-col items-center justify-start x-padding'>
                {/* <div className='w-[90%] py-[12px] bg-[#9B998F] rounded-full text-white text-center font-[600px]'>About This Hotel</div> */}
                {DATA.map((obj , i) => (
                    // <AnimateIn className='w-full' once={true}>
                        <div className={'w-full pb-[66px] mt-[49px]'}>
                            {obj.q && <div className='mb-[48px] w-full flex flex-row items-center justify-center border min-h-[73px] text-white rounded-full text-d-14 font-[600] text-center' style={{background: i % 2 === 0 ? '#96805DCC' : '#9B998F', whiteSpace:'pre-line'}}>
                                <div>{obj.q}</div>
                            </div>}
                            <div ref={refArr[i]} className='title_text w-full flex flex-row items-start justify-start mt-[26px]'>
                                {obj.a}
                            </div>
                            <InViewComponent reffing={refArr[i]} active='title_text_active' delay={i <= 2 ? 2000 : 0 } />
                        </div>
                    // </AnimateIn>
                ))}
            </div>
            <Footer />
            <MaskAnimation />
        </div>
    );
};

export default Faq;